import $ from 'jquery';
import "jquery-mousewheel";
import 'malihu-custom-scrollbar-plugin';
import {throttle} from './lib';

let $frame,
    $button,
    $sidebar,
    $sidebarScroll,
    open = false,
    $window,
    openClass = 'sidebar-open',
    configScrollbar = {
        scrollbarPosition: 'outside',
        snapOffset: 200
    },
    headereight = 0,
    MOBILE_WIDTH,
    scrollbarIsInit = false;

export default function start({button, frame, sidebar, mobileWidth}) {
    $button = $(button);
    $frame = $(frame);
    $sidebar = $(sidebar);
    $window = $(window);
    MOBILE_WIDTH = mobileWidth;
    $sidebarScroll = $('.o-sidebar__wrapper', $sidebar);
    checkScreen();
    addEventListener();
}

function addEventListener() {
    $button.on('click', toggleBar);
    $window.on('resize', throttle(checkScreen, 500));
}

function checkScreen() {
    if ($window.width() > MOBILE_WIDTH) {
        $sidebarScroll.mCustomScrollbar(configScrollbar);
    }else{
        $sidebarScroll.mCustomScrollbar("destroy");
    }

}

function show() {
    $('body').addClass(openClass);
    $("html,body").addClass("overflow");
    setHeightBar();
    $window.on('resize', setHeightBar);
    setTimeout(function () {
        $frame.on('click', hide);
    });
    open = true;
}

function setHeightBar() {
    $sidebarScroll.height($window.height() - headereight);
}

function hide(e) {
    e && e.preventDefault();
    $('body').removeClass(openClass);
    $("html,body").removeClass("overflow");
    $window.off('resize', setHeightBar);
    $frame.off('click', hide);
    open = false;
}

function toggleBar() {
    open = !open;
    if (open) {
        show();
    } else {
        hide();
    }
}



// WEBPACK FOOTER //
// ./modules/sidebar.js